import mergeWith from 'lodash.mergewith';
/**
 * Deep merge of two objects except for arrays.
 * The function doesn't change the "object" and "source".
 */
export default function mergeWithoutArrays(object, source) {
    return mergeWith(object, source, (objValue, srcValue) => {
        if (Array.isArray(objValue)) {
            return srcValue;
        }
        return undefined;
    });
}
